import { useEffect, useState } from 'react';
import { IconPlus } from '@tabler/icons-react';
import StyledButton from '@/components/StyledButton/StyledButton.tsx';
import { IntegrationInstance, IntegrationProvider } from '@/types/integrations.ts';
import { Stack, Text } from '@mantine/core';
import ModalConfirmationButtons from '@/components/StyledModal/ModalConfirmationButtons.tsx';
import StyledModal from '@/components/StyledModal/StyledModal.tsx';
import StyledTextInput from '@/components/StyledInputFields/StyledTextInput.tsx';
import useCreateLinkedDatasetFromURL from '@/hooks/api/datasets/linked/useCreateLinkedDatasetFromURL.ts';
import {
  getFullTenantLabel,
  getIntegrationInstancePrimaryLabel,
} from '@/utils/integrationDisplay.ts';

type props = {
  integration: IntegrationInstance;
  provider: IntegrationProvider;
};

export default function FilePickerButton({ integration, provider }: props) {
  const [opened, setOpened] = useState(false);
  // const [selected, setSelected] = useState<PickedFile[]>([]);

  const [url, setUrl] = useState<string>('');

  const {
    mutate: addLinkedDataset,
    isPending: addingLinkedDataset,
    isSuccess,
  } = useCreateLinkedDatasetFromURL();
  const tenantLabel = getFullTenantLabel(integration.sharepoint_tenant_id);
  const integrationLabel = getIntegrationInstancePrimaryLabel(provider, integration);

  useEffect(() => {
    if (isSuccess) {
      setUrl('');
    }
  }, [isSuccess]);

  return (
    <>
      {/*<Button onClick={() => setOpened(true)} loading={addingLinkedDataset} variant={'outline'}>*/}
      {/*  Open File Picker*/}
      {/*</Button>*/}
      <StyledButton
        size={'sm'}
        variant={'subtle'}
        p={'4.5px'}
        aria-label={`Link file or folder from ${integrationLabel}`}
        onClick={() => setOpened(true)}
        loading={addingLinkedDataset}
        style={{ borderRadius: '50%' }}
      >
        <IconPlus size={16} stroke={2.1} style={{ color: '#757575' }} />
      </StyledButton>

      <StyledModal
        opened={opened}
        onClose={() => setOpened(false)}
        title={'Link file/folder from ' + integrationLabel}
        centered
      >
        <Stack gap="sm">
          {tenantLabel && (
            <Text size="sm" c="#757575">
              {tenantLabel}
            </Text>
          )}
          <StyledTextInput
            radius="md"
            placeholder="file/folder url"
            size="sm"
            value={url}
            onChange={(e) => setUrl(e.target.value)}
            // description={'Enter URL for the file/folder to link'}
            label="URL for the file/folder to link"
            maxLength={1024}
          />
        </Stack>
        <ModalConfirmationButtons
          onClose={() => setOpened(false)}
          onConfirm={() => {
            addLinkedDataset({ integration_id: integration.id, url: url });
          }}
          confirmText={'Save'}
        />
      </StyledModal>

      {/*<FilePicker*/}
      {/*  initialIntegration={integration}*/}
      {/*  initialProvider={provider}*/}
      {/*  opened={opened}*/}
      {/*  onClose={() => setOpened(false)}*/}
      {/*  onSelect={(items) => {*/}
      {/*    setSelected(items);*/}
      {/*    setOpened(false);*/}
      {/*    items.filter((item) => {*/}
      {/*      addLinkedDataset({*/}
      {/*        name: item.file.name,*/}
      {/*        integration_id: item.integration.id,*/}
      {/*        file_id_or_path: item.file.id,*/}
      {/*        is_directory: item.file.is_directory,*/}
      {/*      });*/}
      {/*    });*/}
      {/*  }}*/}
      {/*/>*/}

      {/*{selected.length > 0 && (*/}
      {/*  <div style={{ marginTop: '1rem' }}>*/}
      {/*    <Text fw={500}>Selected Files:</Text>*/}
      {/*    <ul>*/}
      {/*      {selected.map((pickedFile) => (*/}
      {/*        <li key={pickedFile.file.id}>*/}
      {/*          {pickedFile.file.name} ({pickedFile.file.mime_type})*/}
      {/*        </li>*/}
      {/*      ))}*/}
      {/*    </ul>*/}
      {/*  </div>*/}
      {/*)}*/}
    </>
  );
}
